import { AddAngle } from './../utility/AddAngle';
import { AddArc } from './../utility/AddArc';
import { AddCArc } from './../utility/AddCArc';
import { FullExtent } from './../utility/FullExtent';
import { UpdateOffset } from './../utility/UpdateOffset';
import config from './../config/display';

export function convertLegacySketch(
  initialDataParam,
  props,
  stateParam,
  sketchSettings,
) {
  let initialData = JSON.parse(JSON.stringify(initialDataParam));
  // let annotations = [
  //   { xLocation: -1400, yLocation: -1000, NoteText: 'RES UP/PCH DN' },
  //   { xLocation: 12000, yLocation: 200, NoteText: 'RES UP/PCH DN' },
  //   { xLocation: 6400, yLocation: -500, NoteText: 'PCH UP/RES DN' },
  //   { xLocation: -4100, yLocation: 10300, NoteText: '1 OF 3 CARD' },
  // ];
  let state = stateParam
    ? JSON.parse(JSON.stringify(stateParam))
    : JSON.parse(JSON.stringify(config.initialState));
  let char = 'enter';
  let suppressAll = false;
  let suppressAreaLabel = false;
  let tagOffset = null;
  initialData.description = `PID ${
    props.initialData.modifier.improvement.pid
  } ${'\u00A0'}|${'\u00A0'} IMP ID ${
    props.initialData.modifier.improvement.improvementId
  }`;
  if (initialData.sketchCommands[0].details.length === 0) {
    initialData.sketchCommands[2].detailList = [];
    initialData.sketchCommands[2].detailLayers = [];
    for (
      let x = 0;
      x < props.initialData.modifier.improvementDetails.length;
      x++
    ) {
      if (
        props.initialData.modifier.improvementDetails[x].legacySketchCommands
      ) {
        //   processInput(props.initialData.modifier.improvementDetails[x]),
        state.entities[3].commandStartX = 0;
        state.entities[3].commandStartY = 0;
        state.activeDetailIndex = x + 1;
        tagOffset = [0, 0];
        let commands = props.initialData.modifier.improvementDetails[
          x
        ].legacySketchCommands
          .toUpperCase()
          .split(',');
        let moveStartingRegex = /^X[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))$/;
        let tagOffsetRegex = /^XCDS[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))S[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))$/;
        if (tagOffsetRegex.test(commands[0])) {
          let numRegex = /(([0-9]\d*(\.\d+)?)|(\.[0-9]))/g;
          let directionRegex = /[UDLRudlr]/g;
          let nums = commands[0].match(numRegex);
          let dirs = commands[0].match(directionRegex);
          let tagOffsetX = 0;
          let tagOffsetY = 0;
          switch (dirs[1]) {
            case 'U':
              tagOffsetY = tagOffsetY - nums[0] * 10;
              break;
            case 'D':
              tagOffsetY = tagOffsetY + nums[0] * 10;
              break;
            case 'R':
              tagOffsetX = tagOffsetX + nums[0] * 10;
              break;
            case 'L':
              tagOffsetX = tagOffsetX - nums[0] * 10;
              break;
            default:
              break;
          }
          switch (dirs[2]) {
            case 'U':
              tagOffsetY = tagOffsetY - nums[1] * 10;
              break;
            case 'D':
              tagOffsetY = tagOffsetY + nums[1] * 10;
              break;
            case 'R':
              tagOffsetX = tagOffsetX + nums[1] * 10;
              break;
            case 'L':
              tagOffsetX = tagOffsetX - nums[1] * 10;
              break;
            default:
              break;
          }
          tagOffset = [tagOffsetX, tagOffsetY];
        } else if (moveStartingRegex.test(commands[0])) {
          commands[0] = commands[0].replace('X', 'M');
        } else if (commands[0] === 'XAD') {
          suppressAll = true;
        } else if (commands[0] === 'XCD') {
          suppressAreaLabel = true;
        }
        for (let x = 0; x < commands.length; x++) {
          processInput(
            commands[x],
            state,
            update,
            char,
            suppressAll,
            suppressAreaLabel,
            tagOffset,
            x < commands.length - 1,
          );
        }
      }
      initialData.sketchCommands[2].detailList.push(
        sketchSettings && sketchSettings.data && sketchSettings.data.showClass
          ? `${props.initialData.modifier.improvementDetails[x].imprvDetailType}/${props.initialData.modifier.improvementDetails[x].class}`
          : `${props.initialData.modifier.improvementDetails[x].imprvDetailType}`,
      );
      initialData.sketchCommands[2].detailLayers.push(null);
    }
    if (props.initialData.modifier.annotations) {
      let offset = FullExtent({
        entities: state.entities,
        offsetX: 0,
        offsetY: 0,
        spacing: 10,
        windowWidth: 800,
        windowHeight: 800,
        activeLayerIndex: -1,
        textSettings: {
          labelColor: '#000000',
          labelSize: 13,
          annotationColor: '#000000',
          annotationSize: 13,
          dimensionColor: '#000000',
          dimensionSize: 13,
        },
      });
      let yOffset = 0;
      switch (offset.spacing) {
        case 1:
          yOffset = 1500;
          break;
        case 2:
          yOffset = 900;
          break;
        case 3:
          yOffset = 500;
          break;
        case 4:
          yOffset = 300;
          break;
        case 5:
          yOffset = 300;
          break;
        case 6:
          yOffset = 250;
          break;
        case 7:
          yOffset = 250;
          break;
        case 8:
          yOffset = 250;
          break;
        case 9:
          yOffset = 250;
          break;
        case 10:
          yOffset = 200;
          break;
        case 11:
          yOffset = 200;
          break;
        case 12:
          yOffset = 200;
          break;
        case 13:
          yOffset = 200;
          break;
        default:
          yOffset = 100;
      }
      // console.log(state);
      // console.log(offset);
      for (let x = 0; x < props.initialData.modifier.annotations.length; x++) {
        const annotation = props.initialData.modifier.annotations[x];
        if (annotation.NoteText) {
          initialData.sketchCommands[1].annotations.push({
            content: annotation.NoteText,
            coordinate: [
              annotation.xLocation / 10,
              (-1 * annotation.yLocation - yOffset) / 10,
            ],
            detailIndices: [],
            layerIndex: 0,
            lines:
              annotation.xLine || annotation.yLine
                ? [
                    [
                      [
                        annotation.xLocation / 10,
                        (-1 * annotation.yLocation) / 10,
                      ],
                      [
                        (annotation.xLocation + annotation.xLine) / 10,
                        (-1 * (annotation.yLocation + annotation.yLine)) / 10,
                      ],
                    ],
                  ]
                : [],
            offset: [0, 0],
          });
        } else if (
          initialData.sketchCommands[1].annotations[
            initialData.sketchCommands[1].annotations.length - 1
          ]
        ) {
          // initialData.sketchCommands[1].annotations[
          //   initialData.sketchCommands[1].annotations.length - 1
          // ].lines.push([
          //   [annotation.xLocation / 10, (-1 * annotation.yLocation) / 10],
          //   [annotation.xLine / 10, (-1 * annotation.yLine) / 10],
          // ]);
          initialData.sketchCommands[1].annotations[
            initialData.sketchCommands[1].annotations.length - 1
          ].lines.push([
            [annotation.xLocation / 10, (-1 * annotation.yLocation) / 10],
            [
              (annotation.xLocation + annotation.xLine) / 10,
              (-1 * (annotation.yLocation + annotation.yLine)) / 10,
            ],
          ]);
        }
      }
    }
    function update(newState) {
      state = newState;
    }
  }
  initialData.sketchCommands[0] = state.entities[0];
  return initialData;
}

function processInput(
  commandInput,
  state,
  update,
  char,
  suppressAll,
  suppressAreaLabel,
  tagOffset,
  disablePolygonForm,
) {
  let startX = state.entities[3].commandStartX;
  let startY = state.entities[3].commandStartY;
  let targetX = startX;
  let targetY = startY;

  let dAngleRegex =
    '^D([UDLR](([0-9]d*(.d+)?)|(.[0-9])))XD([UDLR](([0-9]d*(.d+)?)|(.[0-9])))';
  let dAngleRegex2 =
    '^D([UDLR](([0-9]d*(.d+)?)|(.[0-9])))X([UDLR](([0-9]d*(.d+)?)|(.[0-9])))';

  if (commandInput.match(dAngleRegex)) {
    commandInput = commandInput.replace(/XD/g, 'X').replace(/^D/g, '');
  } else if (commandInput.match(dAngleRegex2)) {
    commandInput = commandInput.replace(/^D/g, '');
  }

  let convertMajorArcRegex = /^A[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))?[FG](([0-9]\d*(\.\d+)?)|(\.[0-9]))M$/;
  let convertArcRegex = /^A[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))?[FG](([0-9]\d*(\.\d+)?)|(\.[0-9]))$/;
  let dirRegex = /^[UDLRudlr]{1,}$/;
  let dirPlusRegex = /^[M,X][UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))(\/[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))?/;
  let lineRegex = /^D?[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))\D*$/;
  let angleRegex = /^D?([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))[X\/]([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))\D*$/;
  let arcRegex = /^D?[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))A[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))\D*$/;
  let angleArcRegex = /^D?([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))X([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))A[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))\D*$/;
  let circleRegex = /^D?C(([0-9]\d*(\.\d+)?)|(\.[0-9]))\D*$/;
  let legacyBoxRegex = /^[LR]X(([0-9]\d*(\.\d+)?)|(\.[0-9]))[X|\/](([0-9]\d*(\.\d+)?)|(\.[0-9]))$/;
  let bBoxRegex = /^B(([0-9]\d*(\.\d+)?)|(\.[0-9]))$/;
  let numRegex = /(([0-9]\d*(\.\d+)?)|(\.[0-9]))/g;
  let directionRegex = /[UDLRudlr]/g;
  let GFRegex = /[GF]\d+$/g;
  let GFMajorRegex = /[GF]\d+M$/g;
  // ^(([0-9]\d*(\.\d+)?)|(\.[0-9]))[UDLR]\+$ ^(([0-9]\d*(\.\d+)?)|(\.[0-9]))[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))[UDLR]\+$

  if (convertMajorArcRegex.test(commandInput)) {
    let suppressLabelRegex = /^D?([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))X([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))A[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))DD$/;
    let suppressDisplayRegex = /^D?([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))X([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))A[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))DL$/;
    let num = commandInput.match(numRegex);
    let dir = commandInput.match(directionRegex);
    let GFString = '';

    if (dir[0] === 'R') {
      targetX = startX + num[0] * 10;
    }
    if (dir[0] === 'L') {
      targetX = startX - num[0] * 10;
    }
    if (dir[0] === 'U') {
      targetY = startY - num[0] * 10;
    }
    if (dir[0] === 'D') {
      targetY = startY + num[0] * 10;
    }
    if (dir[1] === 'R') {
      targetX = startX + num[1] * 10;
    }
    if (dir[1] === 'L') {
      targetX = startX - num[1] * 10;
    }
    if (dir[1] === 'U') {
      targetY = startY - num[1] * 10;
    }
    if (dir[1] === 'D') {
      targetY = startY + num[1] * 10;
    }

    GFString = commandInput.match(GFMajorRegex)[0];
    dir = GFString.match(/[GF]/g)[0];
    num = GFString.match(numRegex)[0];
    let powerSign = 0;
    if (dir === 'G') {
      powerSign = -1;
    }
    if (dir === 'F') {
      powerSign = 1;
    }

    let length =
      Math.sqrt(
        Math.pow(Math.abs(startX - targetX), 2) +
          Math.pow(Math.abs(startY - targetY), 2),
      ) / 10;
    let diameter = (powerSign * length) / Math.sin((num / 2 / 180) * Math.PI);

    let index = 0;
    let coordinates = [[startX, startY], [targetX, targetY]];
    let arcPower = diameter * 10 * 2;
    // arcPower = calculateArcDirection(coordinates, arcPower, dir[2]);
    let suppress = false;
    let suppressArea = false;
    let suppressDisplay = false;
    if (commandInput.match(suppressLabelRegex) || suppressAll) {
      suppress = true;
    }
    if (commandInput.match(suppressDisplayRegex)) {
      suppressDisplay = true;
    }
    if (suppressAll || suppressAreaLabel) {
      suppressArea = true;
    }
    let newDetails = AddCArc(
      coordinates,
      state.entities[index].details.slice(),
      arcPower,
      state.activeDetailIndex,
      suppress,
      suppressArea,
      tagOffset,
      suppressDisplay,
      state.activeLayerIndex,
      false,
    );
    let entities = Object.assign({}, state.entities);
    entities[0].details = newDetails.data;
    entities[3].commandStartX = targetX;
    entities[3].commandStartY = targetY;
    if (
      (entities[3].originX === null || entities[3].originX === undefined) &&
      state.activeDetailIndex === 1
    ) {
      entities[3].originX = startX;
      entities[3].originY = startY;
    }
    if (
      entities[0].details[newDetails.detailIndex].detailInfo > 0 &&
      entities[2].detailLayers[
        entities[0].details[newDetails.detailIndex].detailInfo - 1
      ] === null
    ) {
      entities[2].detailLayers[
        entities[0].details[newDetails.detailIndex].detailInfo - 1
      ] = state.activeLayerIndex;
    }
    let newdrawhistory = state.drawhistory.slice(0, state.drawhistoryIndex + 1);
    newdrawhistory[state.drawhistoryIndex + 1] = JSON.parse(
      JSON.stringify(entities),
    );
    let tempState = Object.assign({}, state, { entities: entities });
    let offset = UpdateOffset(tempState);
    update(
      Object.assign({}, state, {
        entities: entities,
        startX: 0,
        startY: 0,
        commandInput: '',
        commandActive: true,
        commandTempDetail: null,
        lastActionIndex: [0, newDetails.detailIndex],
        tempData: null,
        highlightX: null,
        highlightY: null,
        mouseDown: false,
        drawhistory: newdrawhistory,
        drawhistoryIndex: state.drawhistoryIndex + 1,
        offsetX: offset.offsetX,
        offsetY: offset.offsetY,
        spacing: offset.spacing,
      }),
    );
  } else if (convertArcRegex.test(commandInput)) {
    let suppressLabelRegex = /^D?([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))X([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))A[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))DD$/;
    let suppressDisplayRegex = /^D?([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))X([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))A[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))DL$/;
    let num = commandInput.match(numRegex);
    let dir = commandInput.match(directionRegex);
    let GFString = '';

    if (dir[0] === 'R') {
      targetX = startX + num[0] * 10;
    }
    if (dir[0] === 'L') {
      targetX = startX - num[0] * 10;
    }
    if (dir[0] === 'U') {
      targetY = startY - num[0] * 10;
    }
    if (dir[0] === 'D') {
      targetY = startY + num[0] * 10;
    }
    if (dir[1] === 'R') {
      targetX = startX + num[1] * 10;
    }
    if (dir[1] === 'L') {
      targetX = startX - num[1] * 10;
    }
    if (dir[1] === 'U') {
      targetY = startY - num[1] * 10;
    }
    if (dir[1] === 'D') {
      targetY = startY + num[1] * 10;
    }

    GFString = commandInput.match(GFRegex)[0];
    dir = GFString.match(/[GF]/g)[0];
    num = GFString.match(numRegex)[0];
    let powerSign = 0;
    if (dir === 'G') {
      powerSign = -1;
    }
    if (dir === 'F') {
      powerSign = 1;
    }

    let length =
      Math.sqrt(
        Math.pow(Math.abs(startX - targetX), 2) +
          Math.pow(Math.abs(startY - targetY), 2),
      ) / 10;
    let diameter = (powerSign * length) / Math.sin((num / 2 / 180) * Math.PI);

    let index = 0;
    let coordinates = [[startX, startY], [targetX, targetY]];
    let arcPower = diameter * 10 * 2;
    // arcPower = calculateArcDirection(coordinates, arcPower, dir[2]);
    let suppress = false;
    let suppressArea = false;
    let suppressDisplay = false;
    if (commandInput.match(suppressLabelRegex) || suppressAll) {
      suppress = true;
    }
    if (commandInput.match(suppressDisplayRegex)) {
      suppressDisplay = true;
    }
    if (suppressAll || suppressAreaLabel) {
      suppressArea = true;
    }
    let newDetails = AddCArc(
      coordinates,
      state.entities[index].details.slice(),
      arcPower,
      state.activeDetailIndex,
      suppress,
      suppressArea,
      tagOffset,
      suppressDisplay,
      state.activeLayerIndex,
      true,
    );
    let entities = Object.assign({}, state.entities);
    entities[0].details = newDetails.data;
    entities[3].commandStartX = targetX;
    entities[3].commandStartY = targetY;
    if (
      (entities[3].originX === null || entities[3].originX === undefined) &&
      state.activeDetailIndex === 1
    ) {
      entities[3].originX = startX;
      entities[3].originY = startY;
    }
    if (
      entities[0].details[newDetails.detailIndex].detailInfo > 0 &&
      entities[2].detailLayers[
        entities[0].details[newDetails.detailIndex].detailInfo - 1
      ] === null
    ) {
      entities[2].detailLayers[
        entities[0].details[newDetails.detailIndex].detailInfo - 1
      ] = state.activeLayerIndex;
    }
    let newdrawhistory = state.drawhistory.slice(0, state.drawhistoryIndex + 1);
    newdrawhistory[state.drawhistoryIndex + 1] = JSON.parse(
      JSON.stringify(entities),
    );
    let tempState = Object.assign({}, state, { entities: entities });
    let offset = UpdateOffset(tempState);
    update(
      Object.assign({}, state, {
        entities: entities,
        startX: 0,
        startY: 0,
        commandInput: '',
        commandActive: true,
        commandTempDetail: null,
        lastActionIndex: [0, newDetails.detailIndex],
        tempData: null,
        highlightX: null,
        highlightY: null,
        mouseDown: false,
        drawhistory: newdrawhistory,
        drawhistoryIndex: state.drawhistoryIndex + 1,
        offsetX: offset.offsetX,
        offsetY: offset.offsetY,
        spacing: offset.spacing,
      }),
    );
  } else if (dirRegex.test(commandInput)) {
    let dir = commandInput.match(directionRegex);
    let entities = Object.assign({}, state.entities);
    for (let x = 0; x < dir.length; x++) {
      switch (dir[x]) {
        case 'U':
          startY = startY - 100;
          break;
        case 'D':
          startY = startY + 100;
          break;
        case 'R':
          startX = startX + 100;
          break;
        case 'L':
          startX = startX - 100;
          break;
        case 'u':
          startY = startY - 10;
          break;
        case 'd':
          startY = startY + 10;
          break;
        case 'r':
          startX = startX + 10;
          break;
        case 'l':
          startX = startX - 10;
          break;
        default:
          break;
      }
    }
    entities[3].commandStartX = startX;
    entities[3].commandStartY = startY;
    let newdrawhistory = state.drawhistory.slice(0, state.drawhistoryIndex + 1);
    newdrawhistory[state.drawhistoryIndex + 1] = JSON.parse(
      JSON.stringify(entities),
    );
    update(
      Object.assign({}, state, {
        entities,
        commandInput: '',
        commandActive: true,
        commandTempDetail: null,
        drawhistory: newdrawhistory,
        drawhistoryIndex: state.drawhistoryIndex + 1,
      }),
    );
  } else if (dirPlusRegex.test(commandInput)) {
    let direction = commandInput.match(directionRegex);
    let single = commandInput.match(/^[M,X][UDLR](([0-9]\d*(\.\d+)?))SU\d$/gi);
    if (direction[1] && single) {
      direction[1] = null;
    }
    let num = commandInput.match(numRegex);

    if (direction[0] === 'R') {
      targetX = startX + num[0] * 10;
    }
    if (direction[0] === 'L') {
      targetX = startX - num[0] * 10;
    }
    if (direction[0] === 'U') {
      targetY = startY - num[0] * 10;
    }
    if (direction[0] === 'D') {
      targetY = startY + num[0] * 10;
    }
    if (direction[1] === 'R') {
      targetX = startX + num[1] * 10;
    }
    if (direction[1] === 'L') {
      targetX = startX - num[1] * 10;
    }
    if (direction[1] === 'U') {
      targetY = startY - num[1] * 10;
    }
    if (direction[1] === 'D') {
      targetY = startY + num[1] * 10;
    }
    let entities = Object.assign({}, state.entities);
    entities[3].commandStartX = targetX;
    entities[3].commandStartY = targetY;

    let newdrawhistory = state.drawhistory.slice(0, state.drawhistoryIndex + 1);
    newdrawhistory[state.drawhistoryIndex + 1] = JSON.parse(
      JSON.stringify(entities),
    );
    let tempState = Object.assign({}, state, { entities: entities });
    let offset = UpdateOffset(tempState);
    update(
      Object.assign({}, state, {
        entities: entities,
        startX: 0,
        startY: 0,
        commandInput: '',
        commandActive: true,
        commandTempDetail: null,
        tempData: null,
        highlightX: null,
        highlightY: null,
        mouseDown: false,
        drawhistory: newdrawhistory,
        drawhistoryIndex: state.drawhistoryIndex + 1,
        offsetX: offset.offsetX,
        offsetY: offset.offsetY,
        spacing: offset.spacing,
      }),
    );
  } else if (circleRegex.test(commandInput)) {
    let suppressLabelRegex = /^D?C(([0-9]\d*(\.\d+)?)|(\.[0-9]))DD$/;
    let suppressDisplayRegex = /^D?C(([0-9]\d*(\.\d+)?)|(\.[0-9]))DL$/;

    let num = commandInput.match(numRegex);

    targetX = startX + num[0] * 10;
    targetY = startY + num[0] * 10;

    // if(dir[0]==="R"){
    //     targetX = startX + num[0]*10;
    // }
    // if(dir[0]==="L"){
    //     targetX = startX - num[0]*10;
    // }
    // if(dir[0]==="U"){
    //     targetY = startY - num[0]*10;
    // }
    // if(dir[0]==="D"){
    //     targetY = startY + num[0]*10;
    // }
    // if(dir[1]==="R"){
    //     targetX = startX + num[1]*10;
    // }
    // if(dir[1]==="L"){
    //     targetX = startX - num[1]*10;
    // }
    // if(dir[1]==="U"){
    //     targetY = startY - num[1]*10;
    // }
    // if(dir[1]==="D"){
    //     targetY = startY + num[1]*10;
    // }
    let suppressLabel = [
      { label: false, display: false },
      { label: false, display: false },
      { label: false, display: false },
      { label: false, display: false },
      { label: false, display: false },
    ];
    let suppressArea = false;
    if (commandInput.match(suppressLabelRegex) || suppressAll) {
      suppressLabel[0] = { label: true, display: false };
    }
    if (commandInput.match(suppressDisplayRegex) || suppressAll) {
      suppressLabel[0] = { label: suppressLabel[0].label, display: true };
    }
    if (suppressAll || suppressAreaLabel) {
      suppressArea = true;
    }
    let coordinates = [[startX, startY], [targetX, targetY]];
    let circle = calculateCircle(state, coordinates);
    let entities = Object.assign({}, state.entities);
    let newDetails = {
      name: 'detail' + entities[0].details.length,
      coordinates: circle.newCoordinates,
      angleData: [false],
      arcData: [false],
      suppressLabel: suppressLabel,
      tagInvisible: suppressArea,
      perimeter: null,
      area: circle.area / 4,
      type: 'circle',
      angle: 0,
      detailInfo: state.activeDetailIndex,
      tagOffset: tagOffset,
      layerIndex: state.activeLayerIndex,
    };
    entities[0].details.push(newDetails);
    entities[3].commandStartX = targetX;
    entities[3].commandStartY = targetY;
    if (
      newDetails.detailInfo > 0 &&
      entities[2].detailLayers[newDetails.detailInfo - 1] === null
    ) {
      entities[2].detailLayers[newDetails.detailInfo - 1] =
        state.activeLayerIndex;
    }
    let newdrawhistory = state.drawhistory.slice(0, state.drawhistoryIndex + 1);
    newdrawhistory[state.drawhistoryIndex + 1] = JSON.parse(
      JSON.stringify(entities),
    );
    let tempState = Object.assign({}, state, { entities: entities });
    let offset = UpdateOffset(tempState);
    update(
      Object.assign({}, state, {
        entities: entities,
        startX: 0,
        startY: 0,
        commandInput: '',
        commandActive: true,
        commandTempDetail: null,
        lastActionIndex: [0, entities[0].details.length - 1],
        tempData: null,
        highlightX: null,
        highlightY: null,
        mouseDown: false,
        drawhistory: newdrawhistory,
        drawhistoryIndex: state.drawhistoryIndex + 1,
        offsetX: offset.offsetX,
        offsetY: offset.offsetY,
        spacing: offset.spacing,
      }),
    );
  } else if (legacyBoxRegex.test(commandInput)) {
    let suppressLabelRegex = /^D?B(([0-9]\d*(\.\d+)?)|(\.[0-9]))DD$/;
    let suppressDisplayRegex = /^D?B(([0-9]\d*(\.\d+)?)|(\.[0-9]))DL$/;
    let num = commandInput.match(numRegex);
    let dir = commandInput.match(/[UDLRudlr]/g);
    targetX = startX + num[0] * 10;
    targetY = startY - num[1] * 10;

    if (dir[0] === 'R') {
      targetX = startX - num[0] * 10;
    }
    if (dir[0] === 'L') {
      targetX = startX + num[0] * 10;
    }
    // if(dir[0]==="U"){
    //     targetY = startY - num[0]*10;
    // }
    // if(dir[0]==="D"){
    //     targetY = startY + num[0]*10;
    // }
    // if(dir[1]==="R"){
    //     targetX = startX + num[1]*10;
    // }
    // if(dir[1]==="L"){
    //     targetX = startX - num[1]*10;
    // }
    // if(dir[1]==="U"){
    //     targetY = startY - num[1]*10;
    // }
    // if(dir[1]==="D"){
    //     targetY = startY + num[1]*10;
    // }
    let suppressLabel = [
      { label: false, display: false },
      { label: false, display: false },
      { label: false, display: false },
      { label: false, display: false },
      { label: false, display: false },
    ];
    let suppressArea = false;
    if (commandInput.match(suppressLabelRegex) || suppressAll) {
      suppressLabel = [
        { label: true, display: false },
        { label: true, display: false },
        { label: true, display: false },
        { label: true, display: false },
        { label: true, display: false },
      ];
    }
    if (commandInput.match(suppressDisplayRegex) || suppressAll) {
      suppressLabel = [
        { label: suppressLabel[0].label, display: true },
        { label: suppressLabel[1].label, display: true },
        { label: suppressLabel[2].label, display: true },
        { label: suppressLabel[3].label, display: true },
        { label: suppressLabel[4].label, display: true },
      ];
    }
    if (suppressAll || suppressAreaLabel) {
      suppressArea = true;
    }
    let coordinates = [
      [startX, startY],
      [targetX, startY],
      [targetX, targetY],
      [startX, targetY],
      [startX, startY],
    ];
    let entities = Object.assign({}, state.entities);
    let newDetails = {
      name: 'detail' + entities[0].details.length,
      coordinates: coordinates,
      angleData: [false, false, false, false, false],
      arcData: [false, false, false, false, false],
      suppressLabel: suppressLabel,
      tagInvisible: suppressArea,
      perimeter: null,
      area: Math.abs(targetX - startX) * Math.abs(targetY - startY),
      type: 'detail',
      angle: 0,
      detailInfo: state.activeDetailIndex,
      tagOffset: [0, 0],
      layerIndex: state.activeLayerIndex,
    };
    entities[0].details.push(newDetails);
    entities[3].commandStartX = targetX;
    entities[3].commandStartY = targetY;
    if (
      newDetails.detailInfo > 0 &&
      entities[2].detailLayers[newDetails.detailInfo - 1] === null
    ) {
      entities[2].detailLayers[newDetails.detailInfo - 1] =
        state.activeLayerIndex;
    }
    let newdrawhistory = state.drawhistory.slice(0, state.drawhistoryIndex + 1);
    newdrawhistory[state.drawhistoryIndex + 1] = JSON.parse(
      JSON.stringify(entities),
    );
    let tempState = Object.assign({}, state, { entities: entities });
    let offset = UpdateOffset(tempState);
    update(
      Object.assign({}, state, {
        entities: entities,
        startX: 0,
        startY: 0,
        commandInput: '',
        commandActive: true,
        commandTempDetail: null,
        lastActionIndex: [0, entities[0].details.length - 1],
        tempData: null,
        highlightX: null,
        highlightY: null,
        mouseDown: false,
        drawhistory: newdrawhistory,
        drawhistoryIndex: state.drawhistoryIndex + 1,
        offsetX: offset.offsetX,
        offsetY: offset.offsetY,
        spacing: offset.spacing,
      }),
    );
  } else if (bBoxRegex.test(commandInput)) {
    let suppressLabelRegex = /^B(([0-9]\d*(\.\d+)?)|(\.[0-9]))DD$/;
    let suppressDisplayRegex = /^B(([0-9]\d*(\.\d+)?)|(\.[0-9]))DL$/;
    let num = commandInput.match(numRegex);
    targetX = startX - num[0] * 10;
    targetY = startY - num[0] * 10;

    // if(dir[0]==="U"){
    //     targetY = startY - num[0]*10;
    // }
    // if(dir[0]==="D"){
    //     targetY = startY + num[0]*10;
    // }
    // if(dir[1]==="R"){
    //     targetX = startX + num[1]*10;
    // }
    // if(dir[1]==="L"){
    //     targetX = startX - num[1]*10;
    // }
    // if(dir[1]==="U"){
    //     targetY = startY - num[1]*10;
    // }
    // if(dir[1]==="D"){
    //     targetY = startY + num[1]*10;
    // }
    let suppressLabel = [
      { label: false, display: false },
      { label: false, display: false },
      { label: false, display: false },
      { label: false, display: false },
      { label: false, display: false },
    ];
    let suppressArea = false;
    if (commandInput.match(suppressLabelRegex) || suppressAll) {
      suppressLabel = [
        { label: true, display: false },
        { label: true, display: false },
        { label: true, display: false },
        { label: true, display: false },
        { label: true, display: false },
      ];
    }
    if (commandInput.match(suppressDisplayRegex) || suppressAll) {
      suppressLabel = [
        { label: suppressLabel[0].label, display: true },
        { label: suppressLabel[1].label, display: true },
        { label: suppressLabel[2].label, display: true },
        { label: suppressLabel[3].label, display: true },
        { label: suppressLabel[4].label, display: true },
      ];
    }
    if (suppressAll || suppressAreaLabel) {
      suppressArea = true;
    }
    let coordinates = [
      [startX, startY],
      [targetX, startY],
      [targetX, targetY],
      [startX, targetY],
      [startX, startY],
    ];
    let entities = Object.assign({}, state.entities);
    let newDetails = {
      name: 'detail' + entities[0].details.length,
      coordinates: coordinates,
      angleData: [false, false, false, false, false],
      arcData: [false, false, false, false, false],
      suppressLabel: suppressLabel,
      tagInvisible: suppressArea,
      perimeter: null,
      area: Math.abs(targetX - startX) * Math.abs(targetY - startY),
      type: 'detail',
      angle: 0,
      detailInfo: state.activeDetailIndex,
      tagOffset: [0, 0],
      layerIndex: state.activeLayerIndex,
    };
    entities[0].details.push(newDetails);
    entities[3].commandStartX = targetX;
    entities[3].commandStartY = targetY;
    if (
      newDetails.detailInfo > 0 &&
      entities[2].detailLayers[newDetails.detailInfo - 1] === null
    ) {
      entities[2].detailLayers[newDetails.detailInfo - 1] =
        state.activeLayerIndex;
    }
    let newdrawhistory = state.drawhistory.slice(0, state.drawhistoryIndex + 1);
    newdrawhistory[state.drawhistoryIndex + 1] = JSON.parse(
      JSON.stringify(entities),
    );
    let tempState = Object.assign({}, state, { entities: entities });
    let offset = UpdateOffset(tempState);
    update(
      Object.assign({}, state, {
        entities: entities,
        startX: 0,
        startY: 0,
        commandInput: '',
        commandActive: true,
        commandTempDetail: null,
        lastActionIndex: [0, entities[0].details.length - 1],
        tempData: null,
        highlightX: null,
        highlightY: null,
        mouseDown: false,
        drawhistory: newdrawhistory,
        drawhistoryIndex: state.drawhistoryIndex + 1,
        offsetX: offset.offsetX,
        offsetY: offset.offsetY,
        spacing: offset.spacing,
      }),
    );
  } else if (arcRegex.test(commandInput)) {
    let modernArcRegex = /^[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))A[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))\D*$/;
    let suppressLabelRegex = /^D?[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))A[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))DD$/;
    let suppressDisplayRegex = /^D?[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))A[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))DL$/;
    let num = commandInput.match(numRegex);

    let dir = commandInput.match(directionRegex);
    if (!modernArcRegex.test(commandInput)) {
      dir.shift();
    }

    if (dir[0] === 'R') {
      targetX = startX + num[0] * 10;
    }
    if (dir[0] === 'L') {
      targetX = startX - num[0] * 10;
    }
    if (dir[0] === 'U') {
      targetY = startY - num[0] * 10;
    }
    if (dir[0] === 'D') {
      targetY = startY + num[0] * 10;
    }
    // if(dir[1]==="R"){
    //     targetX = startX + num[1]*10;
    // }
    // if(dir[1]==="L"){
    //     targetX = startX - num[1]*10;
    // }
    // if(dir[1]==="U"){
    //     targetY = startY - num[1]*10;
    // }
    // if(dir[1]==="D"){
    //     targetY = startY + num[1]*10;
    // }

    let index = 0;
    let coordinates = [[startX, startY], [targetX, targetY]];
    let arcPower = num[1] * 10 * 2;
    arcPower = calculateArcDirection(coordinates, arcPower, dir[1]);
    let suppress = false;
    let suppressArea = false;
    let suppressDisplay = false;
    if (commandInput.match(suppressLabelRegex) || suppressAll) {
      suppress = true;
    }
    if (commandInput.match(suppressDisplayRegex)) {
      suppressDisplay = true;
    }
    if (suppressAll || suppressAreaLabel) {
      suppressArea = true;
    }
    let newDetails = AddArc(
      coordinates,
      state.entities[index].details.slice(),
      arcPower,
      state.activeDetailIndex,
      suppress,
      suppressArea,
      tagOffset,
      suppressDisplay,
      state.activeLayerIndex,
    );
    let entities = Object.assign({}, state.entities);
    entities[0].details = newDetails.data;
    entities[3].commandStartX = targetX;
    entities[3].commandStartY = targetY;
    if (
      (entities[3].originX === null || entities[3].originX === undefined) &&
      state.activeDetailIndex === 1
    ) {
      entities[3].originX = startX;
      entities[3].originY = startY;
    }
    if (
      entities[0].details[newDetails.detailIndex].detailInfo > 0 &&
      entities[2].detailLayers[
        entities[0].details[newDetails.detailIndex].detailInfo - 1
      ] === null
    ) {
      entities[2].detailLayers[
        entities[0].details[newDetails.detailIndex].detailInfo - 1
      ] = state.activeLayerIndex;
    }
    let newdrawhistory = state.drawhistory.slice(0, state.drawhistoryIndex + 1);
    newdrawhistory[state.drawhistoryIndex + 1] = JSON.parse(
      JSON.stringify(entities),
    );
    let tempState = Object.assign({}, state, { entities: entities });
    let offset = UpdateOffset(tempState);
    update(
      Object.assign({}, state, {
        entities: entities,
        startX: 0,
        startY: 0,
        commandInput: '',
        commandActive: true,
        commandTempDetail: null,
        lastActionIndex: [0, newDetails.detailIndex],
        tempData: null,
        highlightX: null,
        highlightY: null,
        mouseDown: false,
        drawhistory: newdrawhistory,
        drawhistoryIndex: state.drawhistoryIndex + 1,
        offsetX: offset.offsetX,
        offsetY: offset.offsetY,
        spacing: offset.spacing,
      }),
    );
  } else if (angleArcRegex.test(commandInput)) {
    let modernArcRegex = /^([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))X([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))A[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))\D*$/;
    let suppressLabelRegex = /^D?([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))X([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))A[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))DD$/;
    let suppressDisplayRegex = /^D?([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))X([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))A[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))DL$/;
    let num = commandInput.match(numRegex);

    let dir = commandInput.match(directionRegex);
    if (!modernArcRegex.test(commandInput)) {
      dir.shift();
    }

    if (dir[0] === 'R') {
      targetX = startX + num[0] * 10;
    }
    if (dir[0] === 'L') {
      targetX = startX - num[0] * 10;
    }
    if (dir[0] === 'U') {
      targetY = startY - num[0] * 10;
    }
    if (dir[0] === 'D') {
      targetY = startY + num[0] * 10;
    }
    if (dir[1] === 'R') {
      targetX = startX + num[1] * 10;
    }
    if (dir[1] === 'L') {
      targetX = startX - num[1] * 10;
    }
    if (dir[1] === 'U') {
      targetY = startY - num[1] * 10;
    }
    if (dir[1] === 'D') {
      targetY = startY + num[1] * 10;
    }

    let index = 0;
    let coordinates = [[startX, startY], [targetX, targetY]];
    let arcPower = num[2] * 10 * 2;
    arcPower = calculateArcDirection(coordinates, arcPower, dir[2]);
    let suppress = false;
    let suppressArea = false;
    let suppressDisplay = false;
    if (commandInput.match(suppressLabelRegex) || suppressAll) {
      suppress = true;
    }
    if (commandInput.match(suppressDisplayRegex)) {
      suppressDisplay = true;
    }
    if (suppressAll || suppressAreaLabel) {
      suppressArea = true;
    }
    let newDetails = AddArc(
      coordinates,
      state.entities[index].details.slice(),
      arcPower,
      state.activeDetailIndex,
      suppress,
      suppressArea,
      tagOffset,
      suppressDisplay,
      state.activeLayerIndex,
    );
    let entities = Object.assign({}, state.entities);
    entities[0].details = newDetails.data;
    entities[3].commandStartX = targetX;
    entities[3].commandStartY = targetY;
    if (
      (entities[3].originX === null || entities[3].originX === undefined) &&
      state.activeDetailIndex === 1
    ) {
      entities[3].originX = startX;
      entities[3].originY = startY;
    }
    if (
      entities[0].details[newDetails.detailIndex].detailInfo > 0 &&
      entities[2].detailLayers[
        entities[0].details[newDetails.detailIndex].detailInfo - 1
      ] === null
    ) {
      entities[2].detailLayers[
        entities[0].details[newDetails.detailIndex].detailInfo - 1
      ] = state.activeLayerIndex;
    }
    let newdrawhistory = state.drawhistory.slice(0, state.drawhistoryIndex + 1);
    newdrawhistory[state.drawhistoryIndex + 1] = JSON.parse(
      JSON.stringify(entities),
    );
    let tempState = Object.assign({}, state, { entities: entities });
    let offset = UpdateOffset(tempState);
    update(
      Object.assign({}, state, {
        entities: entities,
        startX: 0,
        startY: 0,
        commandInput: '',
        commandActive: true,
        commandTempDetail: null,
        lastActionIndex: [0, newDetails.detailIndex],
        tempData: null,
        highlightX: null,
        highlightY: null,
        mouseDown: false,
        drawhistory: newdrawhistory,
        drawhistoryIndex: state.drawhistoryIndex + 1,
        offsetX: offset.offsetX,
        offsetY: offset.offsetY,
        spacing: offset.spacing,
      }),
    );
  } else if (angleRegex.test(commandInput)) {
    // let modernAngleRegex = /^([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))[X\/]([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))\D*$/;
    let suppressLabelRegex = /^D?([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))[X\/]([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))DD$/;
    let suppressDisplayRegex = /^D?([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))[X\/]([UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9])))DL$/;
    let num = commandInput.match(numRegex);
    let dir = commandInput.match(directionRegex);
    // if (!modernAngleRegex.test(commandInput) || suppressAll) {
    //   dir.shift();
    // }

    if (dir[0] === 'R') {
      targetX = startX + num[0] * 10;
    }
    if (dir[0] === 'L') {
      targetX = startX - num[0] * 10;
    }
    if (dir[0] === 'U') {
      targetY = startY - num[0] * 10;
    }
    if (dir[0] === 'D') {
      targetY = startY + num[0] * 10;
    }
    if (dir[1] === 'R') {
      targetX = startX + num[1] * 10;
    }
    if (dir[1] === 'L') {
      targetX = startX - num[1] * 10;
    }
    if (dir[1] === 'U') {
      targetY = startY - num[1] * 10;
    }
    if (dir[1] === 'D') {
      targetY = startY + num[1] * 10;
    }

    let index = 0;
    let coordinates = [[startX, startY], [targetX, targetY]];
    let suppress = false;
    let suppressArea = false;
    let suppressDisplay = false;
    if (commandInput.match(suppressLabelRegex) || suppressAll) {
      suppress = true;
    }
    if (commandInput.match(suppressDisplayRegex)) {
      suppressDisplay = true;
    }
    if (suppressAll || suppressAreaLabel) {
      suppressArea = true;
    }
    let newDetails = AddAngle(
      coordinates,
      state.entities[index].details.slice(),
      state.activeDetailIndex,
      suppress,
      suppressArea,
      tagOffset,
      suppressDisplay,
      state.activeLayerIndex,
      disablePolygonForm,
    );
    let entities = Object.assign({}, state.entities);
    entities[0].details = newDetails.data;
    entities[3].commandStartX = targetX;
    entities[3].commandStartY = targetY;
    if (
      (entities[3].originX === null || entities[3].originX === undefined) &&
      state.activeDetailIndex === 1
    ) {
      entities[3].originX = startX;
      entities[3].originY = startY;
    }
    if (
      entities[0].details[newDetails.detailIndex].detailInfo > 0 &&
      entities[2].detailLayers[
        entities[0].details[newDetails.detailIndex].detailInfo - 1
      ] === null
    ) {
      entities[2].detailLayers[
        entities[0].details[newDetails.detailIndex].detailInfo - 1
      ] = state.activeLayerIndex;
    }
    let newdrawhistory = state.drawhistory.slice(0, state.drawhistoryIndex + 1);
    newdrawhistory[state.drawhistoryIndex + 1] = JSON.parse(
      JSON.stringify(entities),
    );
    let tempState = Object.assign({}, state, { entities: entities });
    let offset = UpdateOffset(tempState);
    update(
      Object.assign({}, state, {
        entities: entities,
        startX: 0,
        startY: 0,
        commandInput: '',
        commandActive: true,
        commandTempDetail: null,
        lastActionIndex: [0, newDetails.detailIndex],
        tempData: null,
        highlightX: null,
        highlightY: null,
        mouseDown: false,
        drawhistory: newdrawhistory,
        drawhistoryIndex: state.drawhistoryIndex + 1,
        offsetX: offset.offsetX,
        offsetY: offset.offsetY,
        spacing: offset.spacing,
      }),
    );
  } else if (lineRegex.test(commandInput)) {
    let modernLineRegex = /^[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))\D*$/;
    let suppressLabelRegex = /^D?[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))DD$/;
    let suppressDisplayRegex = /^D?[UDLR](([0-9]\d*(\.\d+)?)|(\.[0-9]))DL$/;
    let direction = commandInput.match(directionRegex)[1];
    if (modernLineRegex.test(commandInput)) {
      direction = commandInput.match(directionRegex)[0];
    }
    let num = commandInput.match(numRegex)[0];

    if (direction === 'R') {
      targetX = startX + num * 10;
    }
    if (direction === 'L') {
      targetX = startX - num * 10;
    }
    if (direction === 'U') {
      targetY = startY - num * 10;
    }
    if (direction === 'D') {
      targetY = startY + num * 10;
    }
    let index = 0;
    let coordinates = [[startX, startY], [targetX, targetY]];
    let suppress = false;
    let suppressArea = false;
    let suppressDisplay = false;
    if (commandInput.match(suppressLabelRegex) || suppressAll) {
      suppress = true;
    }
    if (commandInput.match(suppressDisplayRegex)) {
      suppressDisplay = true;
    }
    if (suppressAll || suppressAreaLabel) {
      suppressArea = true;
    }
    let newDetails = AddAngle(
      coordinates,
      state.entities[index].details.slice(),
      state.activeDetailIndex,
      suppress,
      suppressArea,
      tagOffset,
      suppressDisplay,
      state.activeLayerIndex,
      disablePolygonForm,
    );
    let entities = Object.assign({}, state.entities);
    entities[0].details = newDetails.data;
    entities[3].commandStartX = targetX;
    entities[3].commandStartY = targetY;
    if (
      (entities[3].originX === null || entities[3].originX === undefined) &&
      state.activeDetailIndex === 1
    ) {
      entities[3].originX = startX;
      entities[3].originY = startY;
    }
    if (
      entities[0].details[newDetails.detailIndex].detailInfo > 0 &&
      entities[2].detailLayers[
        entities[0].details[newDetails.detailIndex].detailInfo - 1
      ] === null
    ) {
      entities[2].detailLayers[
        entities[0].details[newDetails.detailIndex].detailInfo - 1
      ] = state.activeLayerIndex;
    }
    let newdrawhistory = state.drawhistory.slice(0, state.drawhistoryIndex + 1);
    newdrawhistory[state.drawhistoryIndex + 1] = JSON.parse(
      JSON.stringify(entities),
    );
    let tempState = Object.assign({}, state, { entities: entities });
    let offset = UpdateOffset(tempState);

    update(
      Object.assign({}, state, {
        entities: entities,
        startX: 0,
        startY: 0,
        commandInput: '',
        commandActive: true,
        commandTempDetail: null,
        lastActionIndex: [0, newDetails.detailIndex],
        tempData: null,
        highlightX: null,
        highlightY: null,
        mouseDown: false,
        drawhistory: newdrawhistory,
        drawhistoryIndex: state.drawhistoryIndex + 1,
        offsetX: offset.offsetX,
        offsetY: offset.offsetY,
        spacing: offset.spacing,
      }),
    );
  } else {
    update(
      Object.assign({}, state, {
        commandInput: '',
        highlightX: null,
        highlightY: null,
        mouseDown: false,
        commandTempDetail: null,
        commandActive: true,
      }),
    );
  }
}

function calculateArcDirection(coordinates, power, direction) {
  let dragcoords = coordinates;
  let arcPower = power;

  let arcHeight = arcPower / 2;

  let arcControlCoords = [
    [
      (dragcoords[1][0] + dragcoords[0][0]) / 2,
      (dragcoords[1][1] + dragcoords[0][1]) / 2,
    ],
    [dragcoords[0][0], dragcoords[0][1]],
  ];
  arcControlCoords = [
    arcControlCoords[0],
    rotatePoint(
      arcControlCoords[0][0],
      arcControlCoords[0][1],
      arcControlCoords[1][0],
      arcControlCoords[1][1],
      -90,
    ),
  ];
  let arcControlFactor =
    dragcoords[0][0] === dragcoords[1][0] &&
    dragcoords[0][1] === dragcoords[1][1]
      ? 0
      : arcPower /
        Math.sqrt(
          Math.pow(
            Math.abs(arcControlCoords[0][0] - arcControlCoords[1][0]),
            2,
          ) +
            Math.pow(
              Math.abs(arcControlCoords[0][1] - arcControlCoords[1][1]),
              2,
            ),
        );
  arcControlCoords = [
    arcControlCoords[0],
    [
      arcControlCoords[0][0] +
        (arcControlCoords[1][0] - arcControlCoords[0][0]) * arcControlFactor,
      arcControlCoords[0][1] +
        (arcControlCoords[1][1] - arcControlCoords[0][1]) * arcControlFactor,
    ],
  ];
  let arcHeightCoords = [
    [dragcoords[1][0], dragcoords[1][1]],
    [
      (dragcoords[1][0] + dragcoords[0][0]) / 2,
      (dragcoords[1][1] + dragcoords[0][1]) / 2,
    ],
  ];
  arcHeightCoords = [
    arcHeightCoords[0],
    rotatePoint(
      arcHeightCoords[0][0],
      arcHeightCoords[0][1],
      arcHeightCoords[1][0],
      arcHeightCoords[1][1],
      -90,
    ),
  ];
  let arcHeightFactor =
    dragcoords[0][0] === dragcoords[1][0] &&
    dragcoords[0][1] === dragcoords[1][1]
      ? 0
      : arcHeight /
        Math.sqrt(
          Math.pow(Math.abs(arcHeightCoords[0][0] - arcHeightCoords[1][0]), 2) +
            Math.pow(
              Math.abs(arcHeightCoords[0][1] - arcHeightCoords[1][1]),
              2,
            ),
        );
  arcHeightCoords = [
    arcHeightCoords[0],
    [
      arcHeightCoords[0][0] +
        (arcHeightCoords[1][0] - arcHeightCoords[0][0]) * arcHeightFactor,
      arcHeightCoords[0][1] +
        (arcHeightCoords[1][1] - arcHeightCoords[0][1]) * arcHeightFactor,
    ],
  ];
  let controlPoint1 = [arcControlCoords[1][0], arcControlCoords[1][1]];

  arcPower = -1 * arcPower;
  arcControlFactor =
    dragcoords[0][0] === dragcoords[1][0] &&
    dragcoords[0][1] === dragcoords[1][1]
      ? 0
      : arcPower /
        Math.sqrt(
          Math.pow(
            Math.abs(arcControlCoords[0][0] - arcControlCoords[1][0]),
            2,
          ) +
            Math.pow(
              Math.abs(arcControlCoords[0][1] - arcControlCoords[1][1]),
              2,
            ),
        );
  arcControlCoords = [
    arcControlCoords[0],
    [
      arcControlCoords[0][0] +
        (arcControlCoords[1][0] - arcControlCoords[0][0]) * arcControlFactor,
      arcControlCoords[0][1] +
        (arcControlCoords[1][1] - arcControlCoords[0][1]) * arcControlFactor,
    ],
  ];
  arcHeightCoords = [
    [dragcoords[1][0], dragcoords[1][1]],
    [
      (dragcoords[1][0] + dragcoords[0][0]) / 2,
      (dragcoords[1][1] + dragcoords[0][1]) / 2,
    ],
  ];
  arcHeightCoords = [
    arcHeightCoords[0],
    rotatePoint(
      arcHeightCoords[0][0],
      arcHeightCoords[0][1],
      arcHeightCoords[1][0],
      arcHeightCoords[1][1],
      -90,
    ),
  ];
  arcHeightFactor =
    dragcoords[0][0] === dragcoords[1][0] &&
    dragcoords[0][1] === dragcoords[1][1]
      ? 0
      : arcHeight /
        Math.sqrt(
          Math.pow(Math.abs(arcHeightCoords[0][0] - arcHeightCoords[1][0]), 2) +
            Math.pow(
              Math.abs(arcHeightCoords[0][1] - arcHeightCoords[1][1]),
              2,
            ),
        );
  arcHeightCoords = [
    arcHeightCoords[0],
    [
      arcHeightCoords[0][0] +
        (arcHeightCoords[1][0] - arcHeightCoords[0][0]) * arcHeightFactor,
      arcHeightCoords[0][1] +
        (arcHeightCoords[1][1] - arcHeightCoords[0][1]) * arcHeightFactor,
    ],
  ];
  let controlPoint2 = [arcControlCoords[1][0], arcControlCoords[1][1]];

  //
  //
  //

  if (direction === 'U') {
    if (controlPoint1[1] <= controlPoint2[1]) {
      return power;
    } else {
      return -1 * power;
    }
  } else if (direction === 'D') {
    if (controlPoint1[1] >= controlPoint2[1]) {
      return power;
    } else {
      return -1 * power;
    }
  } else if (direction === 'L') {
    if (controlPoint1[0] <= controlPoint2[0]) {
      return power;
    } else {
      return -1 * power;
    }
  } else if (direction === 'R') {
    if (controlPoint1[0] >= controlPoint2[0]) {
      return power;
    } else {
      return -1 * power;
    }
  }
}

function rotatePoint(cx, cy, x, y, angle) {
  var radians = (Math.PI / 180) * angle,
    cos = Math.cos(radians),
    sin = Math.sin(radians),
    nx = cos * (x - cx) + sin * (y - cy) + cx,
    ny = cos * (y - cy) - sin * (x - cx) + cy;
  return [nx, ny];
}

function calculateCircle(state, coordinates) {
  let yDiff = coordinates[1][1] - coordinates[0][1];
  let xDiff = coordinates[1][0] - coordinates[0][0];
  let height = Math.abs(coordinates[1][1] - coordinates[0][1]);
  let width = Math.abs(coordinates[1][0] - coordinates[0][0]);
  let newCoordinates = [
    [coordinates[0][0], coordinates[0][1] + yDiff / 2],
    [coordinates[0][0] + xDiff / 2, coordinates[0][1] + yDiff],
    [coordinates[0][0] + xDiff, coordinates[0][1] + yDiff / 2],
    [coordinates[0][0] + xDiff / 2, coordinates[0][1]],
    [coordinates[0][0], coordinates[0][1] + yDiff / 2],
  ];

  let rx = width;
  let ry = height;
  let area = Math.PI * rx * ry;
  let result = {
    newCoordinates: newCoordinates,
    area: area,
  };
  return result;
}
